import { Navigate, useRoutes } from 'react-router-dom';
import BaseLayout from './layouts/BaseLayout';
import Page404 from './pages/Page404';
import Page403 from './pages/Page403';
import HomePage from './pages/HomePageTemp';
import LandingPage from './pages/LandingPage';
import UserList from './components/User/UserList';
import LoginForm from './components/LoginForm';
import FacilityList from './components/Facility/FacilityList';
import VendorList from './components/Vendor/VendorList';
import ProductList from './components/Product/ProductList';
import PurchasingGroupList from './components/PurchasingGroup/PurchasingGroupList';
import ParentList from './components/Parent/ParentList';
import OrderGuideList from './components/OrderGuide/OrderGuideList';
import ProductCategoryList from './components/ProductCategory/ProductCategoryList';
import OrderList from './components/Order/OrderList';
import OrderSheetTable from './components/OrderSheet/OrderSheetTable';
import CartTable from './components/Cart/CartTable';
import SiteConfigForm from './components/SiteConfig/SiteConfigForm';
import InvoiceList from './components/Invoice/InvoiceList';
import QuickbooksConnect from './components/Quickbooks/QuickbooksConnect';
import FacilityInfo from './components/Facility/FacilityInfo'

export default function Router() {

  const routes = useRoutes([
    {
      path: '/auth',
      element: <BaseLayout />,
      children: [
        { element: <Navigate to="/auth/login" />, index: true },
        { path: 'login', element: <LoginForm /> },
      ],
    },
    {
      path: '/home',
      element: <BaseLayout sidePadding={false} bottomBar={false} />,
      children: [
        { index: true, element: <HomePage /> },
      ],
    },
    {
      path: '/',
      element: <BaseLayout sidePadding={false} bottomBar={false} />,
      children: [
        { element: <Navigate to="/landing" />, index: true },
        { path: 'landing', element: <LandingPage /> },
      ],
    },
    {
      path: '/admin',
      element: <BaseLayout />,
      children: [
        { element: <Navigate to="/facilities" />, index: true },
        { path: 'facilities', element: <FacilityList /> },
        { path: 'purchasingGroups', element: <PurchasingGroupList /> },
        { path: 'parents', element: <ParentList /> },
        { path: 'vendors', element: <VendorList /> },
        { path: 'products', element: <ProductList /> },
        { path: 'orderGuides', element: <OrderGuideList /> },
        { path: 'orderSheet', element: <OrderSheetTable /> },
        { path: 'productCategories', element: <ProductCategoryList /> },
        { path: 'cart', element: <CartTable /> },
        { path: 'users', element: <UserList /> },
        { path: 'orders', element: <OrderList /> },       
        { path: 'siteConfig', element: <SiteConfigForm /> },
        { path: 'invoices', element: <InvoiceList /> },
        { path: 'quickbooks', element: <QuickbooksConnect /> },    
        { path: 'FacilityInfo/:id', element: <FacilityInfo /> }
      ],
    },   
    {
      element: <BaseLayout />,
      children: [
        { element: <Navigate to="/landing" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '403', element: <Page403 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
